import { Component, OnInit } from '@angular/core';
import { PaymentDetails } from '../model/payment-details';
import { BillingOptionsService } from '../services/billing-options.service';

@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.css']
})
export class PaymentReceiptComponent implements OnInit {
  paymentDetails: PaymentDetails;

  constructor(private billingOptionsService: BillingOptionsService) {
  }

  ngOnInit() {
    this.paymentDetails = this.billingOptionsService.getPaymentDetails();
  }

}
